import React from 'react';
import { Box, Button, CssBaseline, Typography } from '@mui/material';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import { useTranslation } from 'react-i18next';

const MaintenanceErrorPage = () => {
  const { t } = useTranslation();

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 3,
      }}>
      <CssBaseline />
      <Box
        sx={{
          width: '100%',
          maxWidth: 760,
          borderRadius: 4,
          bgcolor: 'background.paper',
          border: (theme) => `1px solid ${theme.palette.divider}`,
          boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.08)',
          textAlign: 'center',
          px: { xs: 3, sm: 8 },
          py: { xs: 5, sm: 7 },
        }}>
        <Box
          sx={{
            width: 74,
            height: 74,
            borderRadius: '50%',
            bgcolor: 'rgba(231, 76, 60, 0.14)',
            border: '1px solid rgba(231, 76, 60, 0.35)',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'error.main',
          }}>
          <ConstructionRoundedIcon sx={{ fontSize: 34 }} />
        </Box>

        <Typography
          variant="h1"
          sx={{ mt: 4, color: '#FF6F00', fontWeight: 700 }}>
          {t('maintenancePage.statusCode')}
        </Typography>
        <Typography variant="h3" sx={{ mt: 2, fontWeight: 700 }}>
          {t('maintenancePage.title')}
        </Typography>
        <Typography
          variant="text-lg"
          sx={{
            mt: 2,
            color: 'text.secondary',
            maxWidth: 520,
            margin: '16px auto 0',
          }}>
          {t('maintenancePage.description')}
        </Typography>

        <Button
          variant="text"
          onClick={refreshPage}
          sx={{
            display: 'block',
            mt: 4,
            mx: 'auto',
            fontSize: 24,
            fontWeight: 500,
            textTransform: 'none',
          }}>
          {t('maintenancePage.refreshButton')}
        </Button>
      </Box>
    </Box>
  );
};

export default MaintenanceErrorPage;
